import { Component, inject, input, ViewEncapsulation } from "@angular/core";
import { RouterLink } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import { finalize } from "rxjs";
import { ContactUsComponent } from "src/app/shared/components/contact-us/contact-us.component";
import { LoaderService } from "src/app/shared/components/loader/loader.service";
import { StoreService } from "src/app/services/apps/store/store.service";
import { DashboardAsideNavLink } from "./dashboard-aside-nav-link.model";

@Component({
  selector: "app-dashboard-aside-links-section",
  standalone: true,
  imports: [TranslateModule, TablerIconsModule, RouterLink],
  templateUrl: "./dashboard-aside-links-section.component.html",
  styleUrls: ["./dashboard-aside-links-section.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardAsideLinksSectionComponent {
  private readonly dialog = inject(MatDialog);
  private readonly storeService = inject(StoreService);
  private readonly loaderService = inject(LoaderService);

  readonly sectionId = input.required<string>();
  readonly titleKey = input.required<string>();
  readonly links = input.required<DashboardAsideNavLink[]>();
  readonly footnoteKey = input<string | null>(null);

  onLinkClick(link: DashboardAsideNavLink, event: Event): void {
    if (link.action !== "contact-support") {
      return;
    }

    event.preventDefault();
    this.openContactSupport();
  }

  private openContactSupport(): void {
    this.loaderService.show();
    this.storeService
      .get()
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe((stores) => {
        this.dialog.open(ContactUsComponent, {
          autoFocus: false,
          disableClose: true,
          data: { stores },
        });
      });
  }
}
